var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"icon-tag priority-tag",attrs:{"rounded":""}},[_c('b-icon',{attrs:{"custom-class":"priority-icon","icon":"alpha-p-circle","size":"is-small"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('global.priority')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }